// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionHeader_title__RUN7j","label":"SectionHeader_label__JRnWt","description":"SectionHeader_description__00oXR","centered":"SectionHeader_centered__VrG5O"};